<template>
  <main>
    <div class="container-fluid message">
      <TopTemplate>
        <template #right-element>
          <router-link :to="{ name: 'cantineList' }" class="btn btn-outline-primary button" :disabled="loading">
            <i class="arrow left" />
            {{ $t("button.retour") }}
          </router-link>
        </template>
        <template #left-element>
          <h3>{{ $t("title.addMenu") }}</h3>
        </template>
      </TopTemplate>
      <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-if="!loading">
        <div class="table message-list custom-table">
          <div class>
            <div class="row">
              <div class="col-md-12">
                <div class="table__wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th class="col-md-2">{{ $t("cantine.tab.day") }}</th>
                        <th class="col-md-2">{{ $t("cantine.tab.gouterMorning") }}</th>
                        <th class="col-md-2">{{ $t("cantine.tab.dejeuner") }}
                          </th>
                        <th class="col-md-2">{{ $t("cantine.tab.gouterAfternon") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(planning, index) in planningList" :key="index">

                        <td class="col-md-2 day-custom">
                          {{ planning.day }}
                        </td>
                        <td class="col-md-2">
                          <div class="simple-input">
                            <div>
                              <input v-model="planning.morning_snack" type="text" class="form-control" />
                            </div>
                          </div>
                        </td>
                        <td class="col-md-2">
                          <div class="simple-input">
                            <div>
                              <input v-model="planning.lunch" type="text" class="form-control"
                                :class="{ 'is-invalid': v$.planningList.$each.$response.$data[index].lunch.$error && showRequired }" />
                              <span v-if="v$.planningList.$each.$response.$data[index].lunch.$error && showRequired"
                                class="invalid-feedback">{{ $t('validation.required') }}</span>

                            </div>
                          </div>
                        </td>
                        <td class="col-md-2">
                          <div class="simple-input">
                            <div>
                              <input v-model="planning.afternoon_snack" type="text" class="form-control" />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 buttons">
          <div class="button-right d-flex justify-content-end mb-4">
            <button @click="editCantine()" type="submit" class="btn button btn-primary" :disabled="loading">
              <i class="icon-Check" />
              {{ $t("button.envoi") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import moment from 'moment';
import 'moment/locale/fr';
import CantinesService from "../../services/cantine.service";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

import _ from "lodash";

export default {
  name: "addCantine",
  components: {
    TopTemplate,
  },
  data() {
    return {
      showRequired: false,
      v$: useValidate(),
      loading: false,
      planningList: [],
    
    };
  },
  validations() {
    return {
      planningList: {
        $each: helpers.forEach({
          lunch: {
            //required
          }
        }),
      },
    };
  },


  computed: {},
  created() { },
  mounted() {
    this.listPlanning();
   },
  methods: {
    listPlanning() {
  const daysOfWeek = moment.weekdays();
  for (let i = 0; i < daysOfWeek.length; i++) {
    const day = daysOfWeek[i];
    if (day !== 'dimanche') {
      this.planningList.push({
        day: day,
        morning_snack: '',
        lunch: '',
        afternoon_snack: '',
      });
    }
  }
},
    editCantine() {
      this.loading = true;
      this.v$.$validate();
      this.showRequired =this.v$.$error;
      if (!this.v$.$error) {
        const planningData = this.planningList.map((planning) => ({
          day: planning.day,
          morning_snack: planning.morning_snack,
          lunch: planning.lunch,
          afternoon_snack: planning.afternoon_snack,
        }));

        const data = {
          planning: planningData,
        };
        
        CantinesService.update(data)
          .then((response) => {
            this.$router.push({
              name: "cantineList",
            });
          })
        .finally(() => {
          this.loading = false;
        });
      }
    },
  },
};
</script>
<style scoped>
.table table th, .table table td {
    padding: 13px;
    vertical-align: baseline;
}
.day-custom {
  text-transform: capitalize;
}
.simple-input {
    position: relative;
    margin: 0;
}
.indice {
    font-weight: 400;
}
</style>
